import React from 'react'
import useScrollAnimation from '../hooks/useScrollAnimation'
import './highlights.css'

const highlights = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2L2 7l10 5 10-5-10-5z" />
        <path d="M2 17l10 5 10-5" />
        <path d="M2 12l10 5 10-5" />
      </svg>
    ),
    title: 'Virtual Design & Construction',
    description:
      'Driving VDC coordination across complex building projects, integrating BIM with 4D visual planning and digital construction workflows.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 21h18" />
        <path d="M5 21V7l7-4 7 4v14" />
        <path d="M9 21v-6h6v6" />
        <path d="M9 9h.01" />
        <path d="M15 9h.01" />
        <path d="M9 13h.01" />
        <path d="M15 13h.01" />
      </svg>
    ),
    title: 'Architecture Design',
    description:
      'Designing climate-responsive buildings with passive strategies, parametric design, and performance-driven approaches for residential and commercial projects.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 8C8 10 5.9 16.17 3.82 21.34l1.89.66.95-2.3c.48.17.98.3 1.34.3C19 20 22 3 22 3c-1 2-8 2.25-13 3.25S2 11.5 2 13.5s1.75 3.75 1.75 3.75" />
        <path d="M14 12c-2.5 1-4.5 3-5 6" />
      </svg>
    ),
    title: 'Sustainability & LCA',
    description:
      'Conducting life cycle assessments for embodied carbon reduction and developing data-driven strategies for sustainable infrastructure delivery.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2a4 4 0 0 1 4 4c0 1.95-1.4 3.58-3.25 3.93L12 22" />
        <path d="M12 2a4 4 0 0 0-4 4c0 1.95 1.4 3.58 3.25 3.93" />
        <path d="M8.56 13.44a8 8 0 0 0-2.31 3.3" />
        <path d="M15.44 13.44a8 8 0 0 1 2.31 3.3" />
      </svg>
    ),
    title: 'AI & Machine Learning',
    description:
      'Building AI-powered platforms for building code compliance, design automation, and construction progress tracking using computer vision and NLP.',
  },
]

const Highlights = () => {
  const [sectionRef, isSectionVisible] = useScrollAnimation()

  return (
    <section
      ref={sectionRef}
      className={`highlights-section ${isSectionVisible ? 'animate-in' : ''}`}
    >
      <div className="highlights-container">
        <h2 className="highlights-heading">What I Do</h2>
        <div className="highlights-grid">
          {highlights.map((item, index) => (
            <div
              key={index}
              className="highlights-card"
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="highlights-icon">{item.icon}</div>
              <h3 className="highlights-title">{item.title}</h3>
              <p className="highlights-description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Highlights
